import { makeid } from 'utils/helpers/makeid';

import { RunbookInstruction } from './runbook-instruction';

import type { IClinicalRunbook } from '../use-clinical-runbook';
import type { ICriticalReadingData } from '../types';
import type { TFormItem } from '../../types';

/**
 * #2 Contact Attempt. Primary and secondary numbers are combined into a single
 * question. The "Is there a runbook entry for Unable to Reach?" question (with the
 * runbook instruction) is only shown when "Not Reached" is selected.
 */
export const buildStep2Config = (
  runbook: IClinicalRunbook,
  contact: ICriticalReadingData['contact'],
): TFormItem[] => {
  const items: TFormItem[] = [
    {
      key: makeid(10),
      name: 'contact',
      type: 'radio',
      title: <p>#2 Contact Attempt — Primary/secondary number</p>,
      required: true,
      options: [
        {
          key: makeid(10),
          label: 'Reached (primary or secondary)',
          value: 'reached',
        },
        {
          key: makeid(10),
          label: 'Not Reached (all available numbers attempted)',
          value: 'not-reached',
        },
      ],
    },
  ];

  if (contact === 'not-reached') {
    items.push(
      {
        key: makeid(10),
        name: 'unableToReachRunbookInfo',
        type: 'info',
        html: <RunbookInstruction runbook={runbook} />,
      },
      {
        key: makeid(10),
        name: 'unableToReachRunbook',
        type: 'radio',
        title: <p>Is there a runbook entry for Unable to Reach?</p>,
        required: true,
        options: [
          {
            key: makeid(10),
            label: 'Yes — runbook specifies Do Not Escalate',
            value: 'do-not-escalate',
          },
          {
            key: makeid(10),
            label: 'No entry (or runbook specifies escalate)',
            value: 'no-entry',
          },
        ],
      },
    );
  }

  return items;
};
